import { styled } from "@mui/system"

export const SocialIconBox = styled('div')({
    display: "flex",
    alignItems: "center",
    justifyContent: "justify-between",
    margin: "0 auto",
})

export const IconLink = styled("a")({
    margin: "0 10px",
    background: "transparent",
    textDecoration: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
})

export const ImgContainer = styled('div')<{ dark: string }>(({ theme, dark }) => ({
    width: "32px",
    height: "24px",

    "svg": {
        width: "32px",
        height: "24px",
        color: `${JSON.parse(dark) ? theme.palette.primary.main : theme.palette.common.white}`
    }
}))